import React, { PureComponent } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
// import { Router, Route } from 'react-router-dom'
import createHistory from 'history/createBrowserHistory'

import WTM_map  from './components/wtm.cont';
import WTM_query  from './components/wtm_qry.cont';

const history = createHistory();

const appRoot = () => (
    <Router history={history}>
        <div>
            <Route exact path="/" component={WTM_map}/>
            <Route exact path="/query" component={WTM_query}/>
        </div>
    </Router>
);

export default appRoot


// WEBPACK FOOTER //
// ./src/app.js